exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "trix-editor {\n  background-color: white;\n}\n.trix-mini.input {\n  border-radius: 5px;\n}\n.trix-mini trix-toolbar {\n  display: none;\n}\n.trix-mini trix-editor {\n  margin-top: 0;\n  min-height: 0;\n}\n.border-0 trix-editor {\n  border: 0;\n  padding-left: 0;\n  padding-right: 0;\n  padding-top: 0;\n}", ""]);

// exports
